import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiAlertTriangle } = FiIcons;

const ExpirationBanner = ({ timeRemaining }) => {
  // Format time remaining into hours and minutes
  const formatTimeRemaining = () => {
    const hours = Math.floor(timeRemaining / 60);
    const minutes = timeRemaining % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes} minutes`;
  };
  
  // Determine color based on time remaining
  const getStatusColor = () => {
    if (timeRemaining <= 5) return 'bg-red-50 border-red-200 text-red-700'; // Less than 5 minutes
    if (timeRemaining <= 15) return 'bg-amber-50 border-amber-200 text-amber-700'; // Less than 15 minutes
    return 'bg-blue-50 border-blue-200 text-blue-700'; // More than 15 minutes
  };
  
  // Determine icon based on time remaining
  const getIcon = () => {
    if (timeRemaining <= 5) return FiAlertTriangle;
    return FiClock;
  };

  return (
    <motion.div
      className={`mb-4 px-4 py-3 rounded-lg border ${getStatusColor()} flex items-center`}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <SafeIcon 
        icon={getIcon()} 
        className={`w-5 h-5 mr-2 ${timeRemaining <= 5 ? 'text-red-500' : timeRemaining <= 15 ? 'text-amber-500' : 'text-blue-500'}`} 
      />
      <div className="text-sm">
        <span className="font-medium">Automatic room expiration:</span> This room will automatically expire in {formatTimeRemaining()}.
        {timeRemaining <= 5 && (
          <span className="ml-2 font-medium text-red-600">
            Room closing soon!
          </span>
        )}
      </div>
    </motion.div>
  );
};

export default ExpirationBanner;